/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */
export class CategoryListResponseModel {

  public categoryId: number;
  public categoryName: string;
  public vendorCategoryCommission: number;
  public vendorCategoryId: number;
  public vendorId: number;

  constructor(categoryResponse: any) {
    this.categoryId = categoryResponse.categoryId || '';
    this.categoryName = categoryResponse.categoryName || '';
    this.vendorCategoryCommission = categoryResponse.vendorCategoryCommission || '';
    this.vendorCategoryId = categoryResponse.vendorCategoryId || '';
    this.vendorId = categoryResponse.vendorId || '';

  }
}
